import type { BrandSwipeListProps } from '@/app/_components/widgets/brand-swipe/ui/brand-swipe-list/brand-swipe-list.types';
import type { FC } from 'react';
import dynamic from 'next/dynamic';
import { BrandSwipeProvider } from '@/app/_components/widgets/brand-swipe/ui/brand-swipe-list/brand-swipe-list.context';
import { BrandSwipeListLoader } from '@/app/_components/widgets/brand-swipe/ui/brand-swipe-list/brand-swipe-list.loader';

const BrandSwipeListImpl = dynamic(
  () =>
    import('@/app/_components/widgets/brand-swipe/ui/brand-swipe-list/brand-swipe-list.impl').then(
      (mod) => mod.BrandSwipeListImpl,
    ),
  { ssr: false, loading: () => <BrandSwipeListLoader /> },
);

export const BrandSwipeList: FC<BrandSwipeListProps> = (props) => {
  return (
    <BrandSwipeProvider {...props}>
      <BrandSwipeListImpl {...props} />
    </BrandSwipeProvider>
  );
};
